import React, { useState, useEffect } from "react";
import { List, Modal, Image, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import { DragHandle } from "../../../../../components/DragHandle"; 
import Imageurldata from "../../../../../Imageurldata";

const CategoryOrdering = ({ isOpen, onClose, categories, base_url }) => {
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCategoryList(categories);
  }, [categories]);

  const handleOrderUpdate = async (updatedList) => {
    setLoading(true);
    try {
      const orderPayload = updatedList.map((item, index) => ({
        _id: item._id,
        position: index,
      }));

      const { data } = await axios.post(`${base_url}/recipe/categories/reorder`, {
        order: orderPayload,
      });

      notification.success({
        message: "Category order updated successfully",
      });

      onClose(data.categories); // pass updated categories if needed
    } catch (err) {
      notification.error({
        message: "Failed to update order",
        description: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Reorder Categories"
      visible={isOpen}
      onOk={() => handleOrderUpdate(categoryList)}
      okText="Update Order"
      confirmLoading={loading}
      onCancel={() => onClose()}
      width={600}
    >
      <DragDropContext
        onDragEnd={(result) => {
          const srcIndex = result.source.index;
          const destIndex = result.destination?.index;
          if (destIndex === undefined) return;

          const tempList = [...categoryList];
          tempList.splice(destIndex, 0, tempList.splice(srcIndex, 1)[0]);
          setCategoryList(tempList);
        }}
      >
        <Droppable droppableId="droppable-categories">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ maxHeight: 400, overflowY: "auto" }}
            >
              <List
                bordered
                dataSource={categoryList}
                renderItem={(item, index) => (
                  <Draggable key={item._id} draggableId={item._id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging ? "0 0 .4rem #666" : "none",
                          marginBottom: 8,
                          borderRadius: 4,
                          background: "#fff",
                        }}
                      >
                        <List.Item>
                          <Image
                            src={Imageurldata + item.categoryImageUrl.replaceAll("\\", "/")}
                            width={50}
                            height={50}
                            style={{ objectFit: "cover", borderRadius: 4, marginRight: 10 }}
                            fallback="/no-image.png"
                          />
                          <span>{item.categoryTitle}</span>
                          <DragHandle {...provided.dragHandleProps} />
                        </List.Item>
                      </div>
                    )}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default CategoryOrdering;
